import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _URL from "@babel/runtime-corejs3/core-js/url";
import { findDomFromVNode, createVNode as h, mount } from 'intact-vue';
import { loopDataWithChildrenKey } from './useTree';
import { get, noop, isNullOrUndefined } from 'intact-shared';
export function exportTable(_x, _x2, _x3, _x4, _x5) {
  return _exportTable.apply(this, arguments);
}
function _exportTable() {
  _exportTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getData, data, childrenKey, parentComponet, filename) {
    var collection, _getData, columns, cols, content;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          collection = [];
          _getData = getData(), columns = _getData.columns, cols = _getData.cols; // head
          columns.forEach(function (column) {
            var rows = [];
            // TODO: support grouped header
            column.forEach(function (vNode) {
              var props = vNode.props;
              if (props.ignore) return;
              var dom = findDomFromVNode(vNode, true);
              pushTextContext(rows, dom, props.exportTitle);
            });
            collection.push(rows.join(','));
          });
          // body
          loopDataWithChildrenKey(data, childrenKey, function (data, index) {
            var rows = [];
            cols.forEach(function (col) {
              if (col.ignore) return;
              var blocks = col.$blocks;
              var children = get(data, col.key);
              if (blocks) {
                var template = blocks.template || blocks.default;
                if (template) {
                  children = template(noop, [data, index]);
                }
              }
              var td = h('td', null, children);
              mount(td, null, parentComponet, false, null, []);
              var exportCell = col.exportCell;
              var content = exportCell && exportCell(data, index);
              pushTextContext(rows, td.dom, content);
            });
            collection.push(rows.join(','));
          }, false);
          content = collection.join('\r\n');
          download(content, filename + '.csv');
          return _context.abrupt("return", content);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _exportTable.apply(this, arguments);
}
function pushTextContext(rows, dom, content) {
  var text = isNullOrUndefined(content) ? dom.textContent : content;
  text = '"' + String(_trimInstanceProperty(text).call(text)).replace(/"/g, '""') + '"';
  rows.push(text);
}
export function download(content, filename) {
  if (navigator.msSaveBlob) {
    // IE10+
    var blob = new Blob(["\uFEFF" + content], {
      type: 'text/csv;charset=utf-8'
    });
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement('a');
    if ('download' in link) {
      /**
       * should add \uFEFF, otherwise it will be error codes in MSExcel
       */
      var _blob = new Blob(["\uFEFF" + content], {
        type: 'text/csv;charset=utf-8'
      });
      var url = _URL.createObjectURL(_blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open("data:text/csv,charset=utf-8,%EF%BB%BF" + encodeURI(content));
    }
  }
}